import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { LogoMGA, LogoSpelinspektionen, LogoDGA } from '@comeon/vectors';
import { selectLicense } from '../../brand/ducks/selectors.js';
import { LICENSE_SGA, LICENSE_DGA, LICENSE_OGA, LICENSE_DEGA, LICENSE_KSA } from '~/utils/license-utils.js';
import NullLoader from '../../null-loader.js';

export const Icon = styled.div`
	display: flex;
	align-items: center;
	.logoMGA {
		fill: var(--ingame-jurisdiction-color, rgba(var(--base-01), 1));
		height: 24px;
		width: 100px;
	}

	.logoDGA {
		height: 60px;
	}
`;

const LogoContainer = styled.span`
	padding: 0 12px;
`;

const StyledOGALogo = styled.span`
	height: 40px !important;
	width: 102px !important;
	margin-top: 6px;
`;

const IGOLogo = () => (
	<div className="responsive-footer-logo">
		<StyledOGALogo className="licenses-logos__igo u-dib" data-at="igo-logo" />
	</div>
);

const getLogo = license => {
	switch (license) {
		case LICENSE_KSA:
		case LICENSE_DEGA:
			return null;
		case LICENSE_SGA:
			return (
				<Suspense fallback={<NullLoader />}>
					<LogoContainer>
						<LogoSpelinspektionen height="30px" width="40px" />
					</LogoContainer>
				</Suspense>
			);
		case LICENSE_DGA:
			return (
				<Suspense fallback={<NullLoader />}>
					<LogoContainer>
						<LogoDGA className="logoDGA" />
					</LogoContainer>
				</Suspense>
			);
		case LICENSE_OGA:
			return (
				<Suspense fallback={<NullLoader />}>
					<LogoContainer>
						<IGOLogo className="logoOGA" />
					</LogoContainer>
				</Suspense>
			);
		default:
			return (
				<Suspense fallback={<NullLoader />}>
					<LogoContainer>
						<LogoMGA className="logoMGA" />
					</LogoContainer>
				</Suspense>
			);
	}
};

const JurisdictionLogo = () => {
	const license = useSelector(selectLicense);
	return <Icon data-at="in-game-jurisdiction-logo">{getLogo(license)}</Icon>;
};

export default JurisdictionLogo;
